
export default function makeStorage() {

    const storage = localStorage;

    const setToken = (token) => storage.setItem('SESSION', token)
    const getToken = () => storage.getItem('SESSION')
    const removeToken = () => storage.removeItem('SESSION')

    const getUser = () => storage.getItem('USER')
    const setUser = (value) => storage.setItem('USER', JSON.stringify(value))

    const isStorageEmpty = () => storage.getItem("SESSION") === null;

    const clearSession = () => storage.clear();

    return {
        getToken,
        setToken,
        removeToken,
        getUser,
        setUser,
        clearSession,
        isStorageEmpty
    }

}
